(() => {
  const UNAVAILABLE_CLASS = 'jci-swatch-unavailable';
  let updateTimer;

  function getProductInfo() {
    return document.querySelector('product-info');
  }

  function getAvailabilityData() {
    const script = document.querySelector('[id^="JciVariantAvailability-"]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('JCI variant availability: invalid JSON', error);
      return null;
    }
  }

  function isVariantSoldOut(variant) {
    return !variant.available || variant.forceOutOfStock;
  }

  function getSelectedOptions(productInfo, data) {
    const variantId = productInfo.querySelector('input[name="id"]')?.value;
    if (variantId) {
      const variant = data.variants.find((entry) => String(entry.id) === String(variantId));
      if (variant) return variant.options;
    }

    return data.options.map((optionName) => {
      const group = productInfo.querySelector(`[data-option="${CSS.escape(optionName)}"]`);
      if (!group) return null;

      const selected = group.querySelector(
        '[data-option-value][role="button"][aria-pressed="true"],' +
        '[data-option-value][role="button"][aria-selected="true"],' +
        '[data-option-value][role="button"].jci-swatch-selected],' +
        '[data-option-value][role="button"][data-selected="true"]'
      );

      return selected?.getAttribute('data-option-value') ?? null;
    });
  }

  function isOptionValueAvailable(optionIndex, optionValue, selectedOptions, variants) {
    return variants.some((variant) => {
      if (variant.options[optionIndex] !== optionValue) return false;

      for (let index = 0; index < variant.options.length; index++) {
        if (index === optionIndex) continue;
        if (selectedOptions[index] == null) continue;
        if (variant.options[index] !== selectedOptions[index]) return false;
      }

      return !isVariantSoldOut(variant);
    });
  }

  function setSwatchState(swatch, isAvailable) {
    swatch.classList.toggle(UNAVAILABLE_CLASS, !isAvailable);
    swatch.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
    swatch.setAttribute('tabindex', isAvailable ? '0' : '-1');
  }

  function updateThirdPartySwatches() {
    const productInfo = getProductInfo();
    const data = getAvailabilityData();
    if (!productInfo || !data?.variants?.length) return;

    const selectedOptions = getSelectedOptions(productInfo, data);
    const swatches = productInfo.querySelectorAll('[data-option-value][role="button"]');
    if (!swatches.length) return;

    swatches.forEach((swatch) => {
      const optionValue = swatch.getAttribute('data-option-value');
      const optionGroup = swatch.closest('[data-option]');
      const optionName = optionGroup?.getAttribute('data-option');
      const optionIndex = data.options.indexOf(optionName);

      if (optionIndex === -1 || !optionValue) return;

      const isAvailable = isOptionValueAvailable(optionIndex, optionValue, selectedOptions, data.variants);
      setSwatchState(swatch, isAvailable);
    });
  }

  function scheduleUpdate() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateThirdPartySwatches, 50);
  }

  function initObserver() {
    const productInfo = getProductInfo();
    if (!productInfo || productInfo.dataset.jciSwatchObserver === 'true') return;

    productInfo.dataset.jciSwatchObserver = 'true';

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-selected', 'data-selected', 'style', 'class'] });

    const variantInput = productInfo.querySelector('input[name="id"]');
    variantInput?.addEventListener('change', scheduleUpdate);
  }

  function initPubSub() {
    if (!window.theme?.pubsub?.subscribe || window.theme.__jciSwatchPubSub) return;

    window.theme.__jciSwatchPubSub = theme.pubsub.subscribe(
      theme.pubsub.PUB_SUB_EVENTS.variantChange,
      scheduleUpdate
    );
  }

  function init() {
    updateThirdPartySwatches();
    initObserver();
    initPubSub();
    [500, 1500, 3000].forEach((delay) => window.setTimeout(updateThirdPartySwatches, delay));
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('variant:change', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);

  if (document.readyState !== 'loading') {
    init();
  }
})();
